import styled from "@emotion/styled";

export const Root = styled("div")({
    fontStyle: "italic",
});
